export const NUMBER_OF_EMPLOYEES_TO_SHOW_LOGGED_IN = 20;
export const EMPLOYEES_OFFSET_LOGGED_OUT = 3;
export const EMPLOYEES_OFFSET_LOGGED_IN = 2;
export const NUMBER_OF_EMPLOYEES_TO_SHOW_LOGGED_OUT = 4;
export const BASIC_FLAG = 'BASIC';
export const EXECUTIVE = 'EXECUTIVE';
export const MODERATOR_PREMIUM_FLAG = 'MODERATOR_PREMIUM';
